import React from 'react'
import PropTypes from 'prop-types'
import { constants, links, compose, mixpanel } from 'common/helpers'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { useEffect } from 'sb-hooks'

import Href from 'components/_new/ui/Href/Href'
import Text from 'components/_new/typography/Text/Text'
import Countdown from 'components/ui/countdown/NotSubscribedCountdown/NotSubscribedCountdown'

import messages from './messages'
import s from './OfferCountdownBanner.scss'


const OfferCountdownBanner = ({ gender, pathname }) => {
  const type = 'timer banner 1'

  const handleBannerClick = () => {
    mixpanel.track(constants.analyticsEvents.visitBannerClick, {
      placement: type,
    })

    actions.view.paymentPage.setCouponWithForcedLowerValue(true)
    actions.misc.cookies.setItem(constants.cookieNames.discountCoupon, constants.discountCoupons['25_off'])
  }

  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.visitBanner, {
      offer: '25%',
      placement: pathname,
      type,
      gender,
    })
  })

  return (
    <Href
      className={s.banner}
      to={links.subscribe}
      data-testid="offerCountdownBanner"
      onClick={handleBannerClick}
    >
      <div className={s.bg}>
        <Text message={messages.title} />
        <Countdown className={s.countdown} />
      </div>
    </Href>
  )
}

OfferCountdownBanner.propTypes = {
  gender: PropTypes.string, // @connect
  pathname: PropTypes.string, // @connect
}


export default compose(
  connect({
    gender: 'models.me.gender',
    pathname: 'routing.location.pathname',
  })
)(OfferCountdownBanner)
